export type AppDebugState = {
    webViewTested?: boolean;
    webViewValid?: boolean;
    errors?: string[];
};

export type WebViewDebugSnapshot = {
    tested: boolean;
    valid: boolean;
    versionLabel: string;
    errors: string[];
};

const readAppDebug = (): AppDebugState | undefined =>
    (window as unknown as { __APP_DEBUG__?: AppDebugState }).__APP_DEBUG__;

/** Та же логика, что в public/index.js — для панели после загрузки React */
export const detectWebViewVersion = (): { valid: boolean; label: string } => {
    const ua = navigator.userAgent || "";

    if (ua.includes("Android") && ua.includes("AppleWebKit")) {
        const match = ua.match(/AppleWebKit\/([\d.]+)/);
        return {
            valid: true,
            label: match ? `Android WebKit ${match[1]}` : "Android WebKit",
        };
    }

    if (ua.includes("Chrome") && ua.includes("WebView")) {
        const match = ua.match(/Chrome\/([\d.]+)/);
        return {
            valid: true,
            label: match ? `Chrome WebView ${match[1]}` : "Chrome WebView",
        };
    }

    return { valid: false, label: "Unsupported / desktop browser" };
};

export const getWebViewDebugSnapshot = (): WebViewDebugSnapshot => {
    const appDebug = readAppDebug();
    const detected = typeof navigator !== "undefined" ? detectWebViewVersion() : { valid: false, label: "—" };

    const tested = Boolean(appDebug?.webViewTested);
    const valid = tested ? Boolean(appDebug?.webViewValid) : detected.valid;

    let versionLabel = detected.label;
    if (tested) {
        versionLabel = valid ? detected.label : "Invalid";
    }

    return {
        tested,
        valid,
        versionLabel,
        errors: [...(appDebug?.errors ?? [])],
    };
};

export const subscribeWebViewDebug = (fn: () => void, intervalMs = 500): (() => void) => {
    const id = window.setInterval(fn, intervalMs);
    return () => window.clearInterval(id);
};
